import { UserDetailDto } from '@artemis-software/wr-api';
import { WrMenuItem } from '@shared/components/menu/menu.component';
import TenantTypeEnum = UserDetailDto.TenantTypeEnum;

export const appNavItems: WrMenuItem[] = [
  {
    title: 'Startseite',
    icon: {
      pack: 'fas',
      icon: 'house-chimney',
    },
    link: '/landing',
  },
  {
    title: 'Dashboards',
    icon: {
      pack: 'fas',
      icon: 'diagram-project',
    },
    children: [
      {
        title: 'Benutzer',
        icon: {
          pack: 'fas',
          icon: 'user',
        },
        link: '/dashboard/user',
        permission: 'viewUserDashboard',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Kunde',
        icon: {
          pack: 'fas',
          icon: 'users',
        },
        link: '/dashboard/tenant',
        permission: 'viewExternalTenantDashboard',
      },
      {
        title: 'Bereich',
        icon: {
          pack: 'fas',
          icon: 'map-location-dot',
        },
        link: '/dashboard/region',
        permission: 'viewTeams',
        tenantType: TenantTypeEnum.External,
      },
      {
        title: 'Team',
        icon: {
          pack: 'fas',
          icon: 'users',
        },
        link: '/dashboard/team',
        permission: 'viewTeams',
        tenantType: TenantTypeEnum.External,
      },
      {
        title: 'Gebäude',
        icon: {
          pack: 'fas',
          icon: 'house',
        },
        link: '/dashboard/building-new',
        permission: 'viewBuildingDashboard',
      },
      {
        title: 'Wartungstimer',
        icon: { pack: 'fas', icon: 'hourglass-half' },
        link: '/dashboard/maintenanceTimers',
        permission: 'viewMaintenanceTimerDashboard',
      },
      {
        title: 'Rundgang Dashboard',
        icon: { pack: 'fas', icon: 'clipboard-check' },
        link: '/dashboard/inspections',
        permission: 'viewInternalInspections',
        tenantType: TenantTypeEnum.Internal,
      },
    ],
  },
  {
    title: 'Gebäude',
    icon: {
      pack: 'fas',
      icon: 'house',
    },
    link: '/contractorBuildings',
    permission: 'viewContractorBuildings',
  },
  {
    title: 'Reparaturaufträge',
    icon: {
      pack: 'fas',
      icon: 'screwdriver-wrench',
    },
    link: '/contractor/repairTasks',
    tenantType: TenantTypeEnum.Contractor,
  },
  {
    title: 'Rundgänge',
    icon: {
      pack: 'fas',
      icon: 'clipboard-check',
    },
    link: '/inspections',
    permission: 'viewInternalInspections',
    tenantType: TenantTypeEnum.Internal,
  },
  {
    title: 'Protokolle',
    icon: {
      pack: 'fas',
      icon: 'file-contract',
    },
    tenantType: TenantTypeEnum.Internal,
    children: [
      {
        title: 'Protokolle',
        icon: {
          pack: 'fas',
          icon: 'file-contract',
        },
        link: '/protocols',
        permission: 'viewProtocols',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Protokolltypen',
        icon: {
          pack: 'fas',
          icon: 'file-lines',
        },
        link: '/protocolTypes',
        permission: 'viewProtocolTypes',
        tenantType: TenantTypeEnum.Internal,
      },
    ],
  },
  {
    title: 'Rundgänge',
    icon: {
      pack: 'fas',
      icon: 'clipboard-check',
    },
    link: '/external/inspections',
    permission: 'viewExternalInspections',
    tenantType: TenantTypeEnum.External,
  },
  {
    title: 'Gebäudeverwaltung',
    icon: {
      pack: 'fas',
      icon: 'house',
    },
    children: [
      {
        title: 'Gebäude',
        icon: {
          pack: 'fas',
          icon: 'house',
        },
        link: '/external/buildings',
        permission: 'viewExternalBuildings',
        tenantType: TenantTypeEnum.External,
      },
      {
        title: 'Gebäude',
        icon: {
          pack: 'fas',
          icon: 'house',
        },
        link: '/buildings',
        permission: 'viewInternalBuildings',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Gebäude Arbeitspakete',
        icon: {
          pack: 'fas',
          icon: 'house',
        },
        link: '/buildingWorkItems',
        permission: 'viewInternalBuildingWorkItems',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Übersichtskarte',
        icon: {
          pack: 'fas',
          icon: 'map',
        },
        link: '/map',
        permission: 'viewBuildingMap',
      },
      {
        title: 'Portfolioübersicht',
        icon: {
          pack: 'fas',
          icon: 'ranking-star',
        },
        link: '/portfolioOverview',
        permission: 'viewSensors',
      },
      {
        title: 'QR-Codes generieren',
        icon: {
          pack: 'fas',
          icon: 'qrcode',
        },
        link: '/qrCodes',
        permission: 'viewQrCodeGeneration',
      },
      {
        title: 'Gebäudeanträge',
        icon: {
          pack: 'fas',
          icon: 'folder-plus',
        },
        link: '/buildingApplications',
        permission: 'viewBuildingApplications',
      },
      {
        title: 'Anfragen Center',
        icon: {
          pack: 'fas',
          icon: 'clipboard-question',
        },
        link: '/buildingApplicationsAdmin',
        permission: 'viewBuildingApplicationsAdmin',
      },
    ],
  },
  {
    title: 'Benutzerverwaltung',
    icon: {
      pack: 'fas',
      icon: 'user',
    },
    children: [
      {
        title: 'Meine Benutzer',
        icon: {
          pack: 'fas',
          icon: 'user',
        },
        link: '/tenantUsers',
        permission: 'viewUsers',
      },
      {
        title: 'Admin-Benutzer',
        icon: {
          pack: 'fas',
          icon: 'user',
        },
        link: '/adminUsers',
        permission: 'viewAllTenantUsers',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Rollen',
        icon: {
          pack: 'fas',
          icon: 'user-tag',
        },
        link: '/tenantRoles',
        permission: 'viewTenantRoles',
      },
      {
        title: 'Firmen',
        icon: {
          pack: 'fas',
          icon: 'people-group',
        },
        link: '/internalTenants',
        permission: 'viewInternalTenants',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Kunden',
        icon: {
          pack: 'fas',
          icon: 'people-roof',
        },
        link: '/externalTenants',
        permission: 'viewExternalTenants',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Konzerne',
        icon: {
          pack: 'fas',
          icon: 'sitemap',
        },
        link: '/corporate-groups',
        permission: 'viewCorporateGroup',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Teams',
        icon: {
          pack: 'fas',
          icon: 'users',
        },
        link: '/teams',
        permission: 'viewTeams',
        tenantType: TenantTypeEnum.External,
      },
      {
        title: 'Bereiche',
        icon: {
          pack: 'fas',
          icon: 'map',
        },
        link: '/regions',
        permission: 'viewRegions',
        tenantType: TenantTypeEnum.External,
      },
    ],
  },
  {
    title: 'Monitoring',
    icon: {
      pack: 'fas',
      icon: 'bolt',
    },
    children: [
      {
        title: 'Labels',
        icon: {
          pack: 'fas',
          icon: 'tag',
        },
        link: '/labels',
        permission: 'viewLabels',
      },
    ],
  },
  {
    title: 'Dienstleister',
    icon: {
      pack: 'fas',
      icon: 'hammer',
    },
    children: [
      {
        title: 'Dienstleister',
        icon: {
          pack: 'fas',
          icon: 'hammer',
        },
        link: '/contractorTenants',
        permission: 'viewContractors',
      },
      {
        title: 'Gebäudezuweisung',
        icon: {
          pack: 'fas',
          icon: 'house',
        },
        link: '/contractorBuildingAssignment',
        permission: 'editContractorBuildingAssignments',
      },
      {
        title: 'Zugriffe',
        icon: {
          pack: 'fas',
          icon: 'unlock',
        },
        link: '/contractorScopes',
        permission: 'viewContractorScopes',
      },
      {
        title: 'Ordner Zuordnung',
        icon: {
          pack: 'fas',
          icon: 'folder-tree',
        },
        link: '/contractorAttachmentFolders',
        permission: 'viewContractorAttachmentFolderConfig',
      },
    ],
  },
  {
    title: 'Prüfpunkte',
    icon: {
      pack: 'fas',
      icon: 'square-check',
    },
    tenantType: TenantTypeEnum.Internal,
    children: [
      {
        title: 'Vorlagen',
        icon: {
          pack: 'fas',
          icon: 'file',
        },
        link: '/templates',
        permission: 'viewTemplates',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Prüfpunkt Gruppen',
        icon: {
          pack: 'fas',
          icon: 'check-to-slot',
        },
        link: '/checkpointGroups',
        permission: 'viewCheckpointGroups',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Prüfpunkte',
        icon: {
          pack: 'fas',
          icon: 'square-check',
        },
        link: '/checkpoints',
        permission: 'viewCheckpoints',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Gewichtungen',
        icon: {
          pack: 'fas',
          icon: 'sliders',
        },
        link: '/settings',
        permission: 'viewWeights',
        tenantType: TenantTypeEnum.Internal,
      },
    ],
  },
  {
    title: 'Baukasten',
    icon: {
      pack: 'fas',
      icon: 'list-check',
    },
    tenantType: TenantTypeEnum.Internal,
    children: [
      {
        title: 'Felder',
        icon: {
          pack: 'fas',
          icon: 'font',
        },
        link: '/customFields/fields',
        permission: 'viewGenericForms',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Abschnitte',
        icon: {
          pack: 'fas',
          icon: 'layer-group',
        },
        link: '/customFields/field-sets',
        permission: 'viewGenericForms',
        tenantType: TenantTypeEnum.Internal,
      },
    ],
  },
  {
    title: 'TGA',
    icon: {
      pack: 'fas',
      icon: 'cube',
    },
    children: [
      {
        title: 'TGA Baupläne',
        icon: { pack: 'fas', icon: 'cube' },
        link: '/equipments',
        permission: 'viewTgaTypes',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'TGAs',
        icon: { pack: 'fas', icon: 'cubes' },
        link: '/buildingEquipments',
        permission: 'viewInternalTgas',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'TGAs',
        icon: { pack: 'fas', icon: 'cubes' },
        link: '/external/buildingEquipments',
        permission: 'viewExternalTgas',
        tenantType: TenantTypeEnum.External,
      },
      {
        title: 'TGA Statistik',
        icon: {
          pack: 'fas',
          icon: 'chart-bar',
        },
        link: '/buildingEquipmentStatistic',
        tenantType: TenantTypeEnum.Internal,
        permission: 'viewInternalTgas',
      },
      {
        title: 'TGA Statistik',
        icon: {
          pack: 'fas',
          icon: 'chart-bar',
        },
        link: '/buildingEquipmentExternalStatistic',
        tenantType: TenantTypeEnum.External,
        permission: 'viewExternalTgas',
      },
    ],
  },
  {
    title: 'Wartungstimer',
    icon: {
      pack: 'fas',
      icon: 'hourglass-half',
    },
    children: [
      {
        title: 'Wartungskalender',
        icon: { pack: 'fas', icon: 'calendar-days' },
        link: '/maintenanceTimers/calendar',
        permission: 'viewMaintenanceTimerCalendar',
      },
      {
        title: 'Wartungstimer',
        icon: { pack: 'fas', icon: 'hourglass-half' },
        link: '/maintenanceTimers/overview',
        permission: 'viewInternalMaintenanceTimers',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Wartungstimer',
        icon: { pack: 'fas', icon: 'hourglass-half' },
        link: '/external/maintenanceTimers',
        permission: 'viewExternalMaintenanceTimers',
        tenantType: TenantTypeEnum.External,
      },
      {
        title: 'Wartungstimer-Historie',
        icon: { pack: 'fas', icon: 'book' },
        link: '/maintenanceTimers/historyOverview',
        permission: 'viewInternalMaintenanceTimers',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Wartungstimer-Historie',
        icon: { pack: 'fas', icon: 'book' },
        link: '/external/maintenanceTimers/historyOverview',
        permission: 'viewExternalMaintenanceTimers',
        tenantType: TenantTypeEnum.External,
      },
    ],
    link: '/equipments',
  },
  {
    title: 'Tags',
    icon: {
      pack: 'fas',
      icon: 'tag',
    },
    link: '/tags',
    permission: 'viewTags',
    tenantType: TenantTypeEnum.Internal,
  },
  {
    title: 'Emails',
    icon: {
      pack: 'fas',
      icon: 'envelope',
    },
    link: '/emails',
    permission: 'viewEmails',
  },
  {
    title: 'Archiv',
    icon: {
      pack: 'fas',
      icon: 'image',
    },
    link: '/archive',
    permission: 'viewArchive',
    tenantType: TenantTypeEnum.Internal,
  },
  {
    title: 'Statistiken',
    icon: {
      pack: 'fas',
      icon: 'chart-bar',
    },
    children: [
      {
        title: 'Mitarbeiter',
        icon: {
          pack: 'fas',
          icon: 'user',
        },
        link: '/statistics/user',
        permission: 'viewUserStatistics',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Kunden',
        icon: {
          pack: 'fas',
          icon: 'users',
        },
        link: '/statistics/cooperative',
        permission: 'viewExternalTenantStatistics',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Wartungstimer',
        icon: {
          pack: 'fas',
          icon: 'hourglass-half',
        },
        link: '/statistics/maintenance-timer',
        permission: 'viewMaintenanceTimerStatistics',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Prüfpunktzeilen',
        icon: {
          pack: 'fas',
          icon: 'list-check',
        },
        link: '/statistics/inspection-entry',
        permission: 'viewInspectionEntryStatistics',
      },
      {
        title: 'Mängel/Schäden lt. B1300',
        icon: {
          pack: 'fas',
          icon: 'exclamation-triangle',
        },
        link: '/statistics/defect-report',
        permission: 'viewInspectionEntryStatistics',
      },
    ],
  },
  {
    title: 'Benachrichtigungen',
    icon: {
      pack: 'fas',
      icon: 'bell',
    },
    link: '/notifications',
  },
  {
    title: 'Einstellungen',
    icon: {
      pack: 'fas',
      icon: 'gear',
    },
    tenantType: TenantTypeEnum.Internal,
    children: [
      {
        title: 'Aktionen',
        icon: {
          pack: 'fas',
          icon: 'list-check',
        },
        link: '/configured-actions',
        permission: 'editTenant',
        tenantType: TenantTypeEnum.Internal,
      },
      {
        title: 'Debug',
        icon: {
          pack: 'fas',
          icon: 'bug',
        },
        link: '/debug',
        permission: 'viewDebugInfo',
        tenantType: TenantTypeEnum.Internal,
      },
    ],
  },
];
